import { h } from '@stencil/core';

const Icon = ({ width = '1rem', height = 'auto' }) => {
  return (
    <svg width={width} height={height} viewBox="0 0 48 48" xmlns="http://www.w3.org/2000/svg">
      <circle cx="24" cy="24" r="24" fill="currentColor" class="loader-icons-bar-completed-outer"/>
      <path fill="#fff" d="M21.4 31a2 2 0 0 1-1.4-.6l-5.4-5.5a2 2 0 0 1 2.9-2.8l4 4.1 9.2-8.7a2 2 0 0 1 2.7 3l-10.6 10a2 2 0 0 1-1.4.5Z" class="loader-icons-bar-completed" />
    </svg>
  );
};

export default Icon;
